"use strict";

function classNameForKey(key) {
    const cleaned = String(key).replace(/[^A-Za-z0-9_]/g, "_");
    const ident = /^[A-Za-z_]/.test(cleaned) ? cleaned : "_" + cleaned;
    return "Storage_" + ident;
}

function luaTypeOf(value, depth) {
    if (depth <= 0) return { type: "any", nested: [] };
    if (value === null || value === undefined) return { type: "any", nested: [] };
    const t = typeof value;
    if (t === "string") return { type: "string", nested: [] };
    if (t === "number") return { type: "number", nested: [] };
    if (t === "boolean") return { type: "boolean", nested: [] };
    if (Array.isArray(value)) {
        if (!value.length) return { type: "table", nested: [] };
        const inner = luaTypeOf(value[0], depth - 1);
        return { type: inner.type, nested: inner.nested };
    }
    if (t === "object") {
        return { type: null, nested: null, object: value };
    }
    return { type: "any", nested: [] };
}

function emitClass(name, obj, depth, acc, seen) {
    if (seen[name]) return;
    seen[name] = true;
    const fields = [];
    const nested = [];
    Object.keys(obj || {}).forEach((k) => {
        if (!/^[A-Za-z_][A-Za-z0-9_]*$/.test(k)) return;
        const v = obj[k];
        const info = luaTypeOf(v, depth);
        if (info.object && depth > 0) {
            const child = name + "_" + k;
            emitClass(child, v, depth - 1, acc, seen);
            fields.push({ name: k, type: child });
        } else {
            fields.push({ name: k, type: info.type || "any" });
        }
    });
    acc.push({ name, fields });
    return nested;
}

function storageEntriesToLua(entries) {
    const acc = [];
    const seen = Object.create(null);
    const overloads = [];
    (entries || []).forEach((e) => {
        if (!e || !e.name) return;
        let value = e.value;
        if (typeof value === "string") {
            try {
                value = JSON.parse(value);
            } catch (err) {
                value = { ["_" ]: value };
            }
        }
        const cls = classNameForKey(e.name);
        if (value && typeof value === "object" && !Array.isArray(value)) {
            emitClass(cls, value, 3, acc, seen);
            overloads.push({ key: e.name, type: cls });
        } else {
            const info = luaTypeOf(value, 1);
            overloads.push({ key: e.name, type: info.type || "any" });
        }
    });

    const lines = ["---@meta"];
    acc.forEach((c) => {
        lines.push("");
        lines.push("---@class " + c.name);
        c.fields.forEach((f) => {
            lines.push("---@field " + f.name + " " + f.type);
        });
    });
    lines.push("");
    lines.push("---@class Storage");
    overloads.forEach((o) => {
        lines.push("---@field get fun(self: Storage, key: \"" + o.key.replace(/"/g, "") + "\"): " + o.type);
    });
    lines.push("---@field get fun(self: Storage, key: string): any");
    lines.push("storage = {} ---@type Storage");
    lines.push("");
    return lines.join("\n");
}

module.exports = { storageEntriesToLua, classNameForKey };
